import { useApp } from './AppContext.jsx'

import { CatalogContextProvider } from '../domains/catalog'

import { SECTION_DEPTH, SECTION_ID } from '../shared/constants/sectionIds.js'

import { AppRouteSync } from '../domains/navigation/components/AppRouteSync.jsx'
import { CatalogView } from '../domains/catalog/components/CatalogView.jsx'
import { FavoritesView } from '../domains/favorites/components/FavoritesView.jsx'
import { HeroView } from '../domains/hero/components/HeroView.jsx'
import { MobileNavBar } from '../domains/navigation/components/MobileNavBar.jsx'
import { ProductView } from '../domains/product/components/ProductView.jsx'
import { TiersView } from '../domains/tiers/components/TiersView.jsx'

export function AppRuntime() {
  const { projectConfig, isMobile, activeSectionId, appCapabilities } = useApp()


  return (
    <CatalogContextProvider>
      <AppRouteSync />
      {appCapabilities?.heroSectionEnabled && (!isMobile || activeSectionId === SECTION_ID.HERO) && <HeroView />}
      {isMobile ? (
        <>
          {activeSectionId === SECTION_ID.CATALOG && <CatalogView />}
          {activeSectionId === SECTION_ID.TIERS && appCapabilities?.tiersSectionEnabled && <TiersView />}
          {activeSectionId === SECTION_ID.PRODUCT && appCapabilities?.productSectionEnabled && <ProductView />}
          {activeSectionId === SECTION_ID.FAVORITES && appCapabilities?.favoritesSectionEnabled && <FavoritesView />}
          <MobileNavBar />
        </>
      ) : (
        <>
          <CatalogView />
          {SECTION_DEPTH[activeSectionId] >= SECTION_DEPTH[SECTION_ID.TIERS] &&
            appCapabilities?.tiersSectionEnabled && <TiersView />}
          {SECTION_DEPTH[activeSectionId] >= SECTION_DEPTH[SECTION_ID.PRODUCT] && 
            appCapabilities?.productSectionEnabled && <ProductView />}
          {appCapabilities?.favoritesSectionEnabled && <FavoritesView />}
        </>
      )}
    </CatalogContextProvider>
  )
}
